import type { IWinPriceItem } from '@/api/types'

const MIN_HISTOGRAM_WIN_RATE = 80
const TARGET_HISTOGRAM_WIN_RATE = 90

export interface CountryCpmRecommendation {
  country: string
  iso: string
  recommended: number
}

export const formatCpm = (value: number | string): string => {
  const numberValue = Number(value)
  if (!Number.isFinite(numberValue)) return String(value)

  return numberValue.toFixed(3).replace(/0$/, '')
}

export const cpmRangeError = (min: number, max: number): string => {
  return `Value must be between $${formatCpm(min)} and $${formatCpm(max)}`
}

export const recommendedCpmFromHistogram = (
  prices: IWinPriceItem[]
): number | undefined => {
  return prices
    .filter(
      ({ price, win_rate }) =>
        Number.isFinite(price) &&
        win_rate >= MIN_HISTOGRAM_WIN_RATE &&
        win_rate <= TARGET_HISTOGRAM_WIN_RATE
    )
    .sort((a, b) => b.win_rate - a.win_rate)[0]?.price
}
